<template>
  <ModalContainer v-for="modalId of modals.keys()" :key="modalId" :id="modalId" />
</template>

<script setup lang="ts">
import { useModalStore } from '@/stores/modal'
import ModalContainer from './ModalContainer.vue'
const { modals } = useModalStore()
</script>
